import { Directive, HostListener } from '@angular/core';
import { NgControl } from '@angular/forms';

@Directive({
  selector: '[appTrimFormInput]',
  standalone: true,
})
export class TrimFormInputDirective {
  constructor(private control: NgControl) {}

  @HostListener('blur') onBlur() {
    const currentValue = this.control.control?.value;
    if (currentValue && typeof currentValue === 'string') {
      const trimmedValue = currentValue.trim();
      this.control.control?.setValue(trimmedValue);
    }
  }
}
